import React from 'react';
import { connect } from 'react-redux';

class ManualDetailsView extends React.Component {
  render() {
    const { id } = this.props.match.params;
    const pdfUrl = `/manuals/${id}.pdf`;

    return (
      <div>
        <div className="row mb-2">
          <div className="col-xs-12 col-sm-10 col-md-10">
            <h1 className="text-vw-dark">MANUAL</h1>
          </div>
          <div className="col-xs-12 col-sm-2 col-md-2 align-items-center d-flex justify-content-center">
            <div className="col d-flex justify-content-center">
              <button
                className="btn bg-info text-white"
                onClick={() => window.open(pdfUrl, '_blank')}
              >
                <i className="fas fa-search mr-1"></i>Abrir en Nueva Pestaña
              </button>
            </div>
          </div>
        </div>
        <hr className="bg-vw-light" />
        {/* Embed PDF */}
        <div style={{ width: '100%', height: '80vh' }}>
          <iframe
            src={pdfUrl}
            style={{ width: '100%', height: '100%', border: 'none' }}
            title="Manual PDF"
          />
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  error: state.audits.error,
  loading: state.audits.loading,
  form: state.form,
});

export default connect(mapStateToProps)(ManualDetailsView);
